import { actions } from "./store";
import * as badge from "./apis/badge";

export const flavor$ = {
  store: {
    actions,
  },
  apis: {
    badge,
  },
};
